<template>
  <div>
    <!-- 弹窗 -->
    <van-popup v-model="offlineShow" :close-on-click-overlay="false">
      <img class="pop-bg" src="../../../assets/images/lottery/offline-coupon1.png" />
      <div class="offline-content">
        <div class="content-top">过期时间：{{ offlineCoupon.couponExpireTime | parseTime('{y}-{m}-{d}') }}</div>
        <div class="content-bottom">快去“我的卡券”查看吧！</div>
      </div>

      <!-- <div class="pop-close" @click="offlineHide">
        <img src="../../../assets/images/lottery/off_icon.png" />
      </div> -->
    </van-popup>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  data () {
    return {
      offlineShow: false
    }
  },

  computed: {
    ...mapState({
      offlineCoupon: state => state.lottery.offlineCoupon
    })
  },

  mounted () {
    console.log(this.offlineCoupon)
  },

  methods: {
    offlineAppear () {
      this.offlineShow = true
    },

    offlineHide () {
      this.offlineShow = false
    }
  }
}
</script>

<style lang="less" scoped>
.van-popup {
  width: 270px;
  // min-height: 450px;
  background-color: rgba(0, 0, 0, 0);
  .pop-bg {
    width: 100%;
    // margin-top: 50px;
    // position: absolute;
  }
  .offline-content {
    position: absolute;
    width: 100%;
    height: 65px;
    bottom: 20px;
    padding: 0 10px 0px 15px;
    display: flex;
    flex-direction: column;
    color: #666;
    box-sizing: border-box;
    .content-top {
      width: 100%;
      height: 42px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .content-bottom {
      flex: 1;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  .pop-close {
    width: 39px;
    height: 39px;
    margin: 30px auto 0 auto;
    img {
      width: 100%;
      height: 100%;
    }
  }
}

</style>
